/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bubble_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online bubble chart maker. Paste X, Y and size values to plot three variables at once as sized bubbles.`)
};

const es_bubble_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador gratuito de gráficos de burbujas online. Pega valores X, Y y de tamaño para graficar tres variables a la vez como burbujas dimensionadas.`)
};

const de_bubble_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Blasendiagramm-Ersteller. Fügen Sie X-, Y- und Größenwerte ein, um drei Variablen gleichzeitig als bemessene Blasen darzustellen.`)
};

const nl_bubble_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online bellendiagrammaker. Plak X-, Y- en grootte-waarden om drie variabelen tegelijk te plotten als gedimensioneerde bellen.`)
};

const fr_bubble_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur gratuit de graphique à bulles en ligne. Collez des valeurs X, Y et taille pour tracer trois variables à la fois sous forme de bulles dimensionnées.`)
};

const it_bubble_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore gratuito di grafici a bolle online. Incolla valori X, Y e dimensione per tracciare tre variabili contemporaneamente come bolle dimensionate.`)
};

const pt_br2_bubble_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador gratuito online de gráfico de bolhas. Cole valores de X, Y e tamanho para plotar três variáveis de uma vez como bolhas dimensionadas.`)
};

const pt_bubble_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador gratuito de gráficos de bolhas online. Cole valores de X, Y e tamanho para representar três variáveis de uma vez como bolhas dimensionadas.`)
};

const ja_bubble_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンラインバブルチャート作成ツール。X、Y、サイズの値を貼り付けると、3つの変数をサイズ付きバブルとして同時にプロットできます。`)
};

const zh_bubble_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线气泡图制作工具。粘贴 X、Y 和大小数值，以带大小的气泡形式一次绘制三个变量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bubble_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bubble_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bubble_meta_description", locale)
	if (locale === "en") return en_bubble_meta_description(inputs)
	if (locale === "es") return es_bubble_meta_description(inputs)
	if (locale === "de") return de_bubble_meta_description(inputs)
	if (locale === "nl") return nl_bubble_meta_description(inputs)
	if (locale === "fr") return fr_bubble_meta_description(inputs)
	if (locale === "it") return it_bubble_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_bubble_meta_description(inputs)
	if (locale === "pt") return pt_bubble_meta_description(inputs)
	if (locale === "ja") return ja_bubble_meta_description(inputs)
	return zh_bubble_meta_description(inputs)
};